import React from 'react';

const ScoreDisplay = ({ results, getScoreColor, getScoreBadge }) => {
  return (
    <div className="col-lg-4 text-center mb-3 mb-lg-0">
      <div className="score-display">
        <h1 className={`display-3 mb-2 ${getScoreColor(results.score)}`}>
          {Math.round(results.score)}%
        </h1>
        <span className={`badge-modern ${getScoreBadge(results.score)} mb-2`}>
          {results.correct_answers}/{results.total_questions} Correct
        </span>
        <div className="progress-container mt-2" style={{ height: '8px' }}>
          <div 
            className="progress-bar-modern"
            style={{ width: `${results.score}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ScoreDisplay;
